export default "__VITE_ASSET__CvaNSE_k__"